import React, { useEffect, useState, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import CategoryIcon from "@mui/icons-material/Category";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { fetchHomeBannersData } from "../../action/homeBannersActions";
import { fetchHomeBannerCategories } from "../../action/getHomeBannerCategory";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import CustomDeleteModal from "../../component/Modals/CustomDeleteModal";
import BannerSkeleton from "../../component/skeleton/BannerSkeleton";
import DeleteIconMui from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditCreateCategory from "../../component/admin/goalCategories/EditCreateCategory";
import Pagination from "../../component/Pagination";
import { SECTION_SWITCH_LABEL } from "../../utils/homeFlow";

const goalsColumn = [
  { id: "banner_select", label: "banner_select", width: "5%" },
  { id: "banner_img", label: "BANNER", width: "15%" },
  { id: "category", label: "CATEGORY", width: "20%" },
  { id: "banner_name", label: "CARD TITLE", width: "25%" },
  { id: "sort_order", label: "ORDER", width: "10%" },
  { id: "banner_actions", label: "ACTIONS", width: "15%" },
];

const HomeBanners = () => {
  const navigate = useNavigate();
  const bannersData = useSelector((state) => state.homeBanners);
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [viewBanner, setViewBanner] = useState(false);

  const currentRef = useRef(null);
  const currentCallback = useRef(null);
  const currentTextRef = useRef(null);

  const [editCreateModel, setEditCreateModel] = useState({
    isOpen: false,
    onClose: () =>
      setEditCreateModel((prev) => ({ ...prev, isOpen: false, catName: "" })),
    onConfirm: () => {},
    onCancel: () =>
      setEditCreateModel((prev) => ({ ...prev, isOpen: false, catName: "" })),
    title: "Create Category",
    description: "Enter a name for the new home banner category.",
    cancelText: "Cancel",
    confirmText: "Create",
    catName: "",
  });

  useEffect(() => {
    dispatch(fetchHomeBannersData(token, 1));
    dispatch(fetchHomeBannerCategories(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (bannersData?.data?.success) {
      if (bannersData?.data?.data?.rows?.length > 0) {
        setGoals(bannersData.data?.data?.rows);
        setCurrentPage(bannersData?.data?.data?.currentPage);
        setTotalPages(Math.ceil(bannersData?.data?.data.count / 10));
      } else {
        setGoals("NO Data");
      }
    } else if (bannersData?.data && !bannersData?.data?.success) {
      setGoals(bannersData?.data?.message);
    }
  }, [bannersData]);

  const handleChangePage = (event, newPage) => {
    dispatch(fetchHomeBannersData(token, newPage));
  };

  const handleCreateCategory = async (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) {
      toast.error("Category name is required");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/createHomeBannerCategory`,
        { name: trimmed },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        toast.success(response.data.message);
        dispatch(fetchHomeBannerCategories(token));
        setEditCreateModel((prev) => ({ ...prev, isOpen: false, catName: "" }));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Please try again..");
    }
  };

  const handleDeleteBanner = async (ref) => {
    if (ref.current && ref.current?.id) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/deleteHomeBanner/${ref.current.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          dispatch(fetchHomeBannersData(token, currentPage));
          toast.success("Home banner deleted successfully");
        }
      } catch (error) {
        toast.error("Please try again..");
      } finally {
        setOpenDelete(false);
      }
    } else {
      toast.error("error!!");
    }
  };

  async function handleMultipleDelete(ref) {
    try {
      const ids = Array.from(ref.current.entries()).map((ele) => ele[0]);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleHomeBanner`,
        { ids },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(fetchHomeBannersData(token, currentPage));
        toast.success("Selected Home Banners deleted successfully");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenDelete(false);
    }
  }

  return (
    <>
      <ToastContainer />
      <Box className="page_title custom-header">
        <Typography variant="h1" component="h1">
          Home Banners
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(0,0,0,0.55)", mt: 0.5 }}>
          Manage the {SECTION_SWITCH_LABEL} cards on the user home chooser.
        </Typography>

        <Box sx={{ display: "flex", gap: "10px" }}>
          <IconButton
            onClick={() => {
              if (
                Array.from(multipleSelect.current.entries()).map(
                  (ele) => ele[0]
                ).length === 0
              ) {
                toast.error("select the banner");
                return;
              }
              currentRef.current = multipleSelect.current;
              currentCallback.current = handleMultipleDelete;
              currentTextRef.current =
                "Are You Sure . You want to delete these Selected Home Banners.";
              setOpenDelete(true);
            }}
          >
            <DeleteIconMui />
          </IconButton>
          <Button
            className="create-custom"
            onClick={() =>
              setEditCreateModel((prev) => ({
                ...prev,
                isOpen: true,
                onConfirm: handleCreateCategory,
              }))
            }
          >
            <CategoryIcon className="delete-icon" /> Create Category
          </Button>
          <Button
            className="create-custom"
            onClick={() =>
              navigate("/admin/dashboard/home-banners/add-banner")
            }
          >
            <AddIcon className="delete-icon" /> Create
          </Button>
        </Box>
      </Box>
      <Box className="page_inner">
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="home banners table"
              id="homeBannersTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "700px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_home_banner">
                  {goalsColumn.map((column) =>
                    column.id !== "banner_select" ? (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        {column.label}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id} sx={{ width: column.width }}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(goals) && goals.length > 0 ? (
                  goals.map((value, index) => (
                    <TableRow key={value.id || index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Box className="bannerImageOuter">
                            <img src={value.banner_img} alt="banner" />
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.homeBannerCategory?.name}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.banner_name || "—"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.sort_order ?? 0}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              onClick={() => {
                                deleteSelected.current = value;
                                currentRef.current = value;
                                currentCallback.current = handleDeleteBanner;
                                currentTextRef.current =
                                  "Are You Sure . You want to delete the Home Banner.";
                                setOpenDelete(true);
                              }}
                              sx={{ paddingRight: "0px", minWidth: "0px" }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                deleteSelected.current = value;
                                setViewBanner(true);
                              }}
                            >
                              <VisibilityIcon className="visible_icon" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                navigate(
                                  `/admin/dashboard/home-banners/edit-banner/${value.id}`
                                );
                              }}
                            >
                              <EditIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : goals !== "NO Data" ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <BannerSkeleton key={i} />
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={7} style={{ textAlign: "center" }}>
                      {goals}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      <Modal
        open={viewBanner}
        onClose={() => setViewBanner(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="viewBannerModal">
          <Box className="bannerModalImageOuter">
            {deleteSelected.current && (
              <img
                src={deleteSelected.current.banner_img}
                alt="banner"
              />
            )}
          </Box>
          <IconButton
            className="clear-button"
            onClick={() => setViewBanner(false)}
          >
            <ClearIcon />
          </IconButton>
        </Box>
      </Modal>

      <CustomDeleteModal
        open={openDelete}
        setOpen={setOpenDelete}
        selected={currentRef}
        deleteCallBack={currentCallback}
        customText={currentTextRef.current}
      />

      <EditCreateCategory {...editCreateModel} />
    </>
  );
};

export default HomeBanners;
